import { useTranslation } from "react-i18next";

import { useDispatch, useSelector } from "react-redux";

import React, { useEffect } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Spinner } from "reactstrap";


export default function RenderValidationModal ({
  showValidationPopup,
  handleCloseValidationPopup,
  handleConfirmValidation,
  loadingVerifyConfig,
  centralStack,
  renderElementOverlays,
  renderElementSlot,
  transparentImage,
  handleGenerateImage,
  isValidationInProgress,
  setIsValidationInProgress
}){

    const { t } = useTranslation();
    const dispatch = useDispatch();

    const { loadingDoc } = useSelector((state) => state.Documents);
    const { loadingCreateQuote } = useSelector((state) => state.Quotes);
    const { loadingCheckConfig } = useSelector((state) => state.Configurations);
    const { loadingComponent } = useSelector((state) => state.Components);

    useEffect( () => { // useEffect to handle the validation process in modal with centralStack data

        if (isValidationInProgress && centralStack.length > 0) {
            handleGenerateImage()
        }

    }, [centralStack, isValidationInProgress])

    // Fonction pour générer tous les indices de slots possibles (incluant les demi-slots)
    const generateAllSlotIndices = (maxSlots) => {
        const indices = [];
        for (let i = 0; i < maxSlots; i += 0.5) {
            indices.push(i);
        }
        return indices;
    };

    // Fonction pour rendre les slots d'une ligne dans la popup
    const renderPopupLineSlots = (lineItem) => {
        const slots = lineItem.slots || 0;
        
        if (slots === 0) return (
            <div className="no-slots-message">
                {t('noSlotsForThisLine')}
            </div>
        );

        if (slots > 10) return (
            <div className="no-slots-message">
                {t('noSlotsForThisLine')}
            </div>
        );

        const allSlotIndices = generateAllSlotIndices(slots);

        // Appliquer la même logique de filtrage que dans l'interface principale
        if (lineItem?.ProjProduct?.ref === '350814') {
            return (
                <div className="popup-element-slots">
                    {allSlotIndices.filter(index => index > 4).map((index) => 
                        renderElementSlot(lineItem.stackId, index, false, true)
                    )}
                </div>
            );
        }

        return (
            <div className="popup-element-slots">
                {allSlotIndices.map((index) => 
                    renderElementSlot(lineItem.stackId, index, false, true)
                )}
            </div>
        );
    };

    return (
        <Modal isOpen={showValidationPopup} toggle={handleCloseValidationPopup} className="validation-popup-modal" size="xl">
        <ModalHeader toggle={handleCloseValidationPopup}>
        {t('confirmConfiguration')}
        </ModalHeader>
        
        <ModalBody>
        <p className="validation-message">{t('pleaseConfirmConfiguration')}</p>
        
        <div className="popup-central-container">
            <div className={`popup-central-layout ${centralStack.length > 0 ? 'has-lines' : ''}`}>
            {/* Zone des lignes */}
                <div className={`popup-stack-container ${centralStack.length > 0 ? 'has-lines' : 'empty'}`}>
                {centralStack.length > 0 ? (
                    <div className="popup-stack-items">
                    {centralStack.map((item) => {
                        if (item?.ProjProduct?.ref === 'EMPTY') {
                            return null; // Retourner null au lieu de rien
                        }
                        return (
                        <div key={`popup-line-${item.stackId}`} className="popup-stack-item">
                        <div className="popup-stack-item-container">
                            {/* Base line image */}
                            <img
                            src={item.img || transparentImage}
                            alt={item.lib}
                            title={item.lib}
                            className="popup-stack-item-image"
                            />
                            
                            {/* Overlay elements on the line image */}
                            {renderElementOverlays(item, true)}
                        </div>
                        </div>
                    )})}
                    </div>
                ) : (
                    <div className="empty-container">
                    <span className="empty-container-label">
                        {t('noSlotsAvailable')}
                    </span>
                    </div>
                )}
                </div>
                
                {/* Zone des slots pour éléments */}
                <div className={`popup-elements-container ${centralStack.length > 0 ? 'visible' : 'hidden'}`}>
                {centralStack.length > 0 ? (
                    <div className="popup-slots-container">
                    {centralStack.map((item) => {
                        if (item?.ProjProduct?.ref === 'EMPTY') {
                            return null; // Retourner null au lieu de rien
                        }

                        return (
                            <div 
                            key={`popup-slots-row-${item.stackId}`}
                            className="popup-slots-row"
                            >
                            {renderPopupLineSlots(item)}
                            </div>
                        )
                    })}
                    </div>
                ) : (
                    <div className="empty-slots-container">
                    <span className="empty-container-label">
                        {t('noSlotsAvailable')}
                    </span>
                    </div>
                )}
                </div>
            </div>
            </div>
        </ModalBody>
        
        <ModalFooter>
            <Button color="secondary" onClick={handleCloseValidationPopup}>
            {t('cancel')}
            </Button>
            <Button color="primary" onClick={handleConfirmValidation}>
            {loadingVerifyConfig || loadingDoc || loadingCreateQuote || loadingCheckConfig || loadingComponent ? <Spinner size="sm" /> : t('createQuote')}
            </Button>
        </ModalFooter>
        </Modal>
    );
};